// extracted by mini-css-extract-plugin
module.exports = {"entry_form":"form_entry_form__314y1","input_cnt":"form_input_cnt__33dyb","buttonsCnt":"form_buttonsCnt__2VYUH","addAsNew":"form_addAsNew__1A_Xd"};